import { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";

import AllRoutes from "./Routes/AllRoutes";
import NewNavbar from "./Components/NavbarFooter/NewNavbar";
import Footer from "../src/Components/NavbarFooter/Footer.tsx";
import jwt_decode from "jwt-decode";

import "./App.css";

function App() {
  const [hideSearchResult, setHideSearchResult] = useState(true);
  return (
    <Box className="App" onClick={() => setHideSearchResult(false)}>
      <nav className="fixed-navbar">
        <NewNavbar
          hideSearchResult={hideSearchResult}
          hideSearchResultHandler={setHideSearchResult}
        />
      </nav>
      <main className="main" class="mt-14 md:mt-20">
        <AllRoutes />
      </main>

      <Footer />
    </Box>
  );
}

export default App;
